import { WaitOnCaseStateNotificationViaPolling } from '@core/gateway/notification/caseState/waitOnCaseStateNotificationViaPolling';
import { WaitOnCaseStateNotificationViaSignalR } from '@core/gateway/notification/caseState/waitOnCaseStateNotificationViaSignalR';
import { WaitOnWebauthNotificationViaPolling } from '@core/gateway/notification/webauth/waitOnWebauthNotificationViaPolling';
import { WaitOnWebauthNotificationViaSignalR } from '@core/gateway/notification/webauth/waitOnWebauthNotificationViaSignalR';
import { WaitOnCaseStateNotificationGateway } from '@core/model/gateway/waitOnCaseStateNotificationGateway';
import { WaitOnWebauthNotificationGateway } from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';
import type { Logger } from '@core/model/domain/logger';
import { SignalR } from './signalR';

@injectable()
export class NotificationSwitcher {
  private notificationMethodToUse: 'POLLING' | 'SIGNAL_R' | 'NONE' = 'NONE';

  constructor(
    @inject(SERVICE_ID.signalRFeatureFlag)
    private isSignalREnabled: boolean,
    @inject(SERVICE_ID.logger)
    private logger: Logger,
    @inject(SERVICE_ID.signalR)
    private signalR: SignalR,
    @inject(SERVICE_ID.waitOnCaseStateNotificationViaPolling)
    private waitOnCaseStateNotificationViaPolling: WaitOnCaseStateNotificationViaPolling,
    @inject(SERVICE_ID.waitOnCaseStateNotificationViaSignalR)
    private waitOnCaseStateNotificationViaSignalR: WaitOnCaseStateNotificationViaSignalR,
    @inject(SERVICE_ID.waitOnWebauthNotificationViaPolling)
    private waitOnWebauthNotificationViaPolling: WaitOnWebauthNotificationViaPolling,
    @inject(SERVICE_ID.waitOnWebauthNotificationViaSignalR)
    private waitOnWebauthNotificationViaSignalR: WaitOnWebauthNotificationViaSignalR
  ) {}

  async initialize(userToken: string) {
    if (!this.isSignalREnabled) {
      this.notificationMethodToUse = 'POLLING';
      this.logger.logTrace(`Notification method used : ${this.notificationMethodToUse}`);
      return;
    }

    try {
      await this.signalR.ensureInitialization(userToken);
      this.notificationMethodToUse = 'SIGNAL_R';
    } catch (error) {
      this.logger.logException(error);
      this.notificationMethodToUse = 'POLLING';
    }

    this.logger.logTrace(`Notification method used : ${this.notificationMethodToUse}`);
  }

  getWaitOnCaseStateNotificationGateway(): WaitOnCaseStateNotificationGateway {
    if (this.notificationMethodToUse === 'POLLING') {
      return this.waitOnCaseStateNotificationViaPolling;
    }

    return this.waitOnCaseStateNotificationViaSignalR;
  }

  getWaitOnWebauthNotificationGateway(): WaitOnWebauthNotificationGateway {
    if (this.notificationMethodToUse === 'POLLING') {
      return this.waitOnWebauthNotificationViaPolling;
    }

    return this.waitOnWebauthNotificationViaSignalR;
  }
}
